import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import * as actions from './account.actions';

@Injectable()
export class AccountEffects {

    /**
     * This effect detects when the active account id changed and triggers an
     * ActiveAccountChangedAction with both the previous and new values.
     *
     * We use the ActiveAccountChangedAction in other effects to trigger
     * behaviours based on this event.
     */
    @Effect({dispatch: false})
    accountChanged$ = this.actions$
        .ofType(actions.SELECT)
        .switchMap(() => {
            return this.appFacade.objects.account.store
                .getCurrentAndPreviousSelectedId()
                .take(1)
                .do(ids => {

                    if (ids.selected === ids.selectedPrevious) {
                        return;
                    }

                    this.appFacade.store.dispatch(
                        new actions.ActiveAccountChangedAction({
                            from: ids.selectedPrevious,
                            to: ids.selected
                        })
                    );
                });
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account/account.effects.ts